/**
 *  @class
 *  @function QuickNavigation
 */
if (!customElements.get('quick-navigation')) {
  class QuickNavigation extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');

      this._onDocumentClick = (e) => {
        if (this.details.open && !this.contains(e.target)) {
          this.details.removeAttribute('open');
        }
      };
      this._onKeyUp = (e) => {
        if (this.details.open && e.code && e.code.toUpperCase() === 'ESCAPE') {
          this.details.removeAttribute('open');
          this.summary.focus();
        }
      };

      document.addEventListener('click', this._onDocumentClick);
      document.addEventListener('keyup', this._onKeyUp);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this._onDocumentClick);
      document.removeEventListener('keyup', this._onKeyUp);
    }
  }
  customElements.define('quick-navigation', QuickNavigation);
}
